export function PersonalInfo() {
  return <>Do Not Sell My Personal Information</>;
}
